import { i18n_t as $t } from '@utils/i18n';

// BE doesn't support i18n, so we need to handle it on the FE
export function localizeMetaGroups (metaGroups) {
    return metaGroups.map((metaGroup) => {
        let localizedName = metaGroup.name;
        switch (metaGroup.name) {
            case 'General Notification':
                localizedName = $t('metaGroups.General Notification');
                break;
            case 'Education':
                localizedName = $t('metaGroups.Education');
                break;
            case 'Research':
                localizedName = $t('metaGroups.Research');
                break;
            default:
        }

        return {
            ...metaGroup,
            name: localizedName,
        };
    });
}
